import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useCorrectionsDetailsStyles = makeStyles({
  alertButton: {
    border: "1px solid ".concat(palette.shades[300])
  },
  billTableHeader: {
    alignItems: 'center',
    backgroundColor: palette.common.white,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    padding: '16px 24px',
    position: 'relative'
  },
  billTableHeaderTitle: {
    marginLeft: '16px'
  },
  chip: {
    marginLeft: '5px'
  },
  corrected: {
    color: palette.success.main
  },
  correctedChip: {
    textDecoration: 'line-through'
  },
  correctionTrigger: {
    marginBottom: '5px',
    marginLeft: '5px',
    '& .MuiChip-root': {
      marginLeft: '5px'
    }
  },
  correctionTriggers: {
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'column'
  },
  correctionTriggersBlock: {
    padding: '16px 24px'
  },
  original: {
    color: palette.error.main,
    textDecoration: 'line-through'
  },
  summaryBlock: {
    '& + &': {
      marginLeft: '24px',
      paddingLeft: '24px',
      borderLeft: "1px solid ".concat(palette.shades[300])
    }
  },
  summaryBlocks: {
    display: 'flex',
    alignContent: 'center'
  },
  summaryWrapper: {
    margin: '18px 32px'
  },
  utilityProviderDetails: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  }
});
export default useCorrectionsDetailsStyles;